export const FONT_FACING = "FONT-FACING";
export const DOMAIN_GROUP = "DOMAIN";